export default __webpack_public_path__ + "static/media/fw-zoe-er-Rose Gold.d41b11b8.mp4";